/**
 * 美国项目：金额统一按 USD 展示（Salesforce 风格本地化）
 * @param {unknown} value
 * @returns {string}
 */
export function formatUsd(value) {
  if (value === null || value === undefined || value === '') return '—'
  const n = Number(value)
  if (Number.isNaN(n)) return '—'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(n)
}
